export const RoleKeys = {
  user: 'user',
  representative: 'representative',
  moderator: 'moderator',
  builder: 'builder',
  metrics: 'metrics',
  admin: 'admin',
  master: 'master',
}
